import React from 'react';
import './WhatsAppButton.css'; // Arquivo de estilo para o botão

function WhatsAppButton() {
  return (
    <div className="whatsapp-button">
      <a href="https://wa.me/5531996102844" target="_blank" rel="noopener noreferrer">
        <img src="https://teraquiz.com/microservice.provide.files/url?file=1712840166894994452.svg" alt="WhatsApp"/>
      </a>
    </div>
  );
}

export default WhatsAppButton;
